class KitComponentList {
  constructor() {
    this.variants = JSON.parse(localStorage.getItem('pdpVariants'))

    this.isLoading = false
    this.loadingFinished = new Event('loadingFinished')

    this.modal = document.getElementById('kit_component_list_modal')
    this.modalBtn = document.getElementById('kit_component_list')
    this.modalCloseBtn = document.getElementById('kit_component_list_modal_close')
    this.modalDetails = document.querySelector('.kit_component_list_modal_details')

    this.modalBtn.addEventListener('click', this.openModal.bind(this))
    this.modalCloseBtn.addEventListener('click', this.closeModal.bind(this))
    window.addEventListener('click', this.closeModalOnOutsideClick.bind(this))

    this.currentHandle = window.location.pathname.split('/').pop()
    this.init()
  }

  async init() {
    const currentSku = this.getCurrentSku()

    if (currentSku) {
      this.toggleLoading(true)
      const initialAssociations = await this.getAssociations(currentSku)
      if (initialAssociations.length === 0) {
        this.modalBtn.style.display = 'none'
      }
      this.toggleLoading(false)
      this.populateModal(null, initialAssociations)
    }

    this.observeSkuChanges()
  }

  toggleLoading(isLoading) {
    if (isLoading) {
      this.modalBtn.classList.add('kit-component-button-disabled', 'kit-component-button-loading')
      this.modalBtn.disabled = true
    } else {
      this.modalBtn.classList.remove('kit-component-button-disabled', 'kit-component-button-loading')
      this.modalBtn.disabled = false
    }
  }

  getCurrentSku() {
    const element = document.querySelector('.productView-info-value[data-get-sku]')
    return element ? element.innerText : null
  }

  observeSkuChanges() {
    const skuElement = document.querySelector('.productView-info-value[data-get-sku]')
    let lastSku = null
    let timeoutId = null

    const observer = new MutationObserver((mutations) => {
      clearTimeout(timeoutId)

      timeoutId = setTimeout(() => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'characterData' || mutation.type === 'childList') {
            const newSku = skuElement.innerText
            if (newSku !== lastSku) {
              this.populateModal(newSku)
              lastSku = newSku
            }
          }
        })
      }, 300)
    })

    observer.observe(skuElement, { childList: true })
  }

  async getAssociations(sku) {
    try {
      const response = await fetch(
        `https://bdsgallery-function.azurewebsites.net/api/associations?sku=${sku}`
      )
      const text = await response.text()

      try {
        const jsonData = JSON.parse(text)
        if (response.ok) {
          return jsonData
        } else {
          console.error(`Error response for SKU ${sku}:`, jsonData)
          return []
        }
      } catch (e) {
        console.warn(`Response for SKU ${sku} is not valid JSON:`, text)
        return []
      }
    } catch (error) {
      console.error(`Fetch Error for SKU ${sku}:`, error)
      return []
    }
  }

  async populateModal(sku, initialAssociations) {
    const currentSku = sku || this.getCurrentSku()
    let associations = initialAssociations

    if (!associations) {
      this.toggleLoading(true)
      associations = await this.getAssociations(currentSku)
      this.toggleLoading(false)
    }

    const vInfo = this.variants.find((v) => v.sku === currentSku)

    if (!vInfo || !associations || associations.length === 0) {
      this.modalBtn.style.display = 'none'
      return
    }

    let modalHtml = this.generateModalHtml(vInfo, associations)
    this.modalDetails.innerHTML = modalHtml
    this.modalBtn.style.display = 'block'
    this.toggleLoading(false)
  }

  generateModalHtml(vInfo, associations) {
    let modalHtml = `<div class="custom_modal_cart_item" style="border: 2px solid gray; padding: 1% 2%; margin-bottom: 5px;">
      <table style="width: 100%; padding: 0 2%; text-align: left; border-collapse: collapse;">
      <colgroup><col style="width: 5%"/><col style="width: 15%"/><col style="width: 70%"/><col style="width: 10%"/></colgroup>
      <thead style="font-size: 15px; border-bottom: 2px solid gray;">
      <tr><th>${parseInt(vInfo.qty) < 0 ? 0 : vInfo.qty}</th><th>${vInfo.sku}</th><th>${vInfo.title}</th><th>${vInfo.price}</th></tr></thead>`

    for (const aItem of associations) {
      modalHtml += `<tbody style="font-size: 13px;"><tr><th>${aItem.qty}</th><th>${aItem.sku}</th><th>${aItem.title}</th><th></th></tr></tbody>`
    }
    modalHtml += '</table></div>'

    return modalHtml
  }

  openModal() {
    this.modalBtn.disabled = true
    this.modal.style.display = 'block'
  }

  closeModal() {
    this.modal.style.display = 'none'
    this.modalBtn.disabled = false
  }

  closeModalOnOutsideClick(event) {
    if (event.target === this.modal) {
      this.closeModal()
    }
  }
}

document.addEventListener('DOMContentLoaded', async function () {
  const kitList = new KitComponentList()
})
